<script>
    export let title;
    export let subtitle;
    export let imgSrc;
    export let imgAlt;
</script>

<div class="card hover:shadow-xl">
    <img src={imgSrc} alt={imgAlt} class="w-full h-32 sm:h-48 object-cover">
    <div class="m-4">
        <span class="font-bold text-lg">{title}</span>
        <span class="block text-gray-500">{subtitle}</span>
    </div>
    <!-- <div class="badge">
        <svg class="w-5 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
        </svg>
        <span>25 mins</span>
    </div> -->
</div>